export default defineAppConfig({
  ui: {
    primary: 'gray-bg',
  }
})